import FindAddressesForPostcode from '@/services/logistics/postcodeLookupService/FindAddressesForPostcode';
import LegacyFetchAddressesForPostcode from '@/services/logistics/postcodeLookupService/LegacyFetchAddressesForPostcode';

export default class PostcodeLookupService {
    /**
     * Fetch list of available address via API for requested postcode.
     *
     * @param {String} postcode
     * @deprecated
     * @returns {Array}
     */
    async fetchAddressesForPostcode(postcode) {
        return (new LegacyFetchAddressesForPostcode()).handle(postcode);
    }

    /**
     * Handle fetching the list of addresses associated with the given postcode string and country.
     *
     * @param {string} postcode
     * @param {string|null} countryIso
     *
     * @returns {Promise}
     */
    static findAddressesForPostcode(postcode, countryIso = 'uk') {
        return (new FindAddressesForPostcode()).handle(postcode, countryIso);
    }
}
